module.exports = __webpack_public_path__ + "static/media/cases_impressos_nec_05.42046c20.jpg";